import React from 'react';
import axios from 'axios';

import { useTimeModal } from '../../TimeModal/TimeModalContext';
import { normalizeDate } from '../../../Utils/GlobalUtils';

import Loading from '../../Loading';

import FileUploadField from '../../FileUploadField';

import styles from '../../../styles/DynamicModal.module.css';

import IconContainer from '../../IconContainer';
import { ReactComponent as XIcon } from '../../../icons/x-close.svg';

const EditEmploymentHistory = ({ closeModal, id, action, userId, onSuccess }) => {
    const { openTimeModal } = useTimeModal();

    const [formInfo, setFormInfo] = React.useState({
        id: '',
        user_id: '',
        type: 'Работа на руководящей должности',
        organization_name: '',
        admission_date: '',
        job_title: '',
        leaving_date: '',
    });
    const [status, setStatus] = React.useState('');
    const [loading, setLoading] = React.useState(true);

    

    const handleLogout = () => {
        localStorage.removeItem('token');
        window.location.href = '/';
    }
    React.useEffect(() => {
        if (action=='change') {
            const token = localStorage.getItem('token');
            if (!token) handleLogout();
            setStatus(<a><Loading type='inline' /></a>);

            axios.get(`/api/get-single-employment?id=${id}`)
            .then((response) => {
                setFormInfo(response.data);
                setStatus(null);
            }).catch((error) => {
                console.error(error);
                setStatus(<a className='mainLabelError'>Не удалось загрузить данные. {error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}</a>);
            }).finally(() => {
                setLoading(false);
            })
        } else {
            setLoading(false);
        }
    }, [])

    const handleChange = (field) => (e) => {
        const value = e.target.type === 'checkbox' ? e.target.checked : e.target.value;

        setFormInfo((prev) => ({ ...prev, [field]: value }));

        setStatus('Сохраните изменения');

        setErrorsForm((prevErrors) => {
        if (!prevErrors[field]) return prevErrors;
            const updatedErrors = { ...prevErrors };
            delete updatedErrors[field];
            return updatedErrors;
        });
    };

    const [errorsForm, setErrorsForm] = React.useState({});
        const validateForm = () => {
        const newErrors = {};
    
        if (!formInfo.organization_name) {
            newErrors.organization_name = 'Обязательное поле';
        }
        if (!formInfo.admission_date) {
            newErrors.admission_date = 'Обязательное поле';
        }
        if (formInfo.organization_name && (formInfo.organization_name.length < 2 || formInfo.organization_name.length > 150)) {
            newErrors.organization_name = 'Значение не может быть меньше 2 и более 150 символов';
        }
        if (formInfo.job_title && (formInfo.job_title.length < 2 || formInfo.job_title.length > 50)) {
            newErrors.job_title = 'Значение не может быть меньше 2 и более 50 символов';
        }
        if (formInfo.type==='Работа на руководящей должности' && !formInfo.job_title) {
            newErrors.job_title = 'Обязательное поле';
        }
    
        setErrorsForm(newErrors);
        if (Object.keys(newErrors).length > 0) {
            setStatus(<a className='mainLabelError'>Данные не сохранены. Проверьте корректность введенных полей</a>);
            return false;
        } else {
            return true;
        }
    };

    const addData = () => {
        const formData = new FormData();

        formData.append('user_id', userId);
        formData.append('type', formInfo.type);
        formData.append('organization_name', formInfo.organization_name);
        formData.append('admission_date', normalizeDate(formInfo.admission_date));
        formData.append('job_title', formInfo.job_title);
        formData.append('leaving_date', normalizeDate(formInfo.leaving_date));

        if (files.certificate) {
        formData.append('file_certificate', files.certificate);
        }

        axios.put('/api/add-new-employment', formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
        .then(() => {
            setStatus('Новые данные добавлены');
            onSuccess();
            openTimeModal('Данные успешно добавлены', 'success');
            closeModal();
        })
        .catch((error) => {
            console.error(error);
            setStatus(<a className='mainLabelError'>Данные не сохранены. {error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}</a>);
        }).finally(() => {
            setLoading(false);
        })
    }

    const changeData = () => {
        const token = localStorage.getItem('token');

        axios.put(`/api/change-verification`, {
            id: formInfo.id,
            user_id: userId,
            type: formInfo.type,
            organization_name: formInfo.organization_name,
            admission_date: normalizeDate(formInfo.admission_date),
            job_title: formInfo.job_title,
            leaving_date: normalizeDate(formInfo.leaving_date),
        }, {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        }).then(() => {
            setStatus('Данные изменены');
            onSuccess();
            openTimeModal('Данные успешно изменены', 'success');
            closeModal();
        }).catch((error) => {
            console.error(error);
            setStatus(<a className='mainLabelError'>Данные не сохранены. {error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}</a>);
        }).finally(() => {
            setLoading(false);
        })
    }

    const handleSave = () => {
        setLoading(true);
        setStatus(<a><Loading type='inline' /></a>);

        if (validateForm()) {
            if (action=='add') addData();
            if (action=='change') changeData();
        }
        setLoading(false);
    };

    const [files, setFiles] = React.useState({
        certificate: null,
    });
    const handleFileChange = (field) => (e) => {
        const file = e.target.files[0];
        setFiles((prev) => ({
            ...prev,
            [field]: file || null,
        }));
    };
    const handleFileReset = (field) => () => {
        setFiles((prev) => ({
            ...prev,
            [field]: null,
        }));
    };


    return (
        <div className={styles.liningOver}>
            <div className={styles.lining} onClick={(e) => e.stopPropagation()}>
                <div className={styles.header}>
                    <h1>
                        {action=='add' && 'Добавление'}{action=='change' && 'Редактирование'}
                        &nbsp;сведений о трудовой деятельности
                    </h1>
                    <IconContainer Icon={XIcon} onClick={closeModal} size = '20' color = 'black' className = '' />
                </div>
                <div className={styles.main}>
                    <div className='labelInputWrapper'>
                        <a className='label'>Выберите вариант</a>
                        <div className='labelInputRight'>
                            <div className='radioSwitchWrapper'>
                                <label className={`radioSwitchLabel ${formInfo.type === 'Работа на руководящей должности' ? 'selected' : ''}`}>
                                    <input
                                        type='radio'
                                        name='typeSelector'
                                        value='Работа на руководящей должности'
                                        checked={formInfo.type === 'Работа на руководящей должности'}
                                        onChange={handleChange('type')}
                                    />
                                    <span>Работа на руководящей должности</span>
                                </label>
                                <label className={`radioSwitchLabel ${formInfo.type === 'Стажировка в качестве помощника арбитражного управляющего' ? 'selected' : ''}`}>
                                    <input
                                        type='radio'
                                        name='typeSelector'
                                        value='Стажировка в качестве помощника арбитражного управляющего'
                                        checked={formInfo.type === 'Стажировка в качестве помощника арбитражного управляющего'}
                                        onChange={handleChange('type')}
                                    />
                                    <span>Стажировка в качестве помощника арбитражного управляющего</span>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div className='labelInputWrapper'>
                        <a className='label'>{formInfo.type==='Работа на руководящей должности' ? 'Наименование организации' : 'Наименование СРО'}</a>
                        <div className='labelInputRight'>
                            <div className='inputWrapper'>
                                <input 
                                type='text' 
                                value={formInfo.organization_name} 
                                onChange={handleChange('organization_name')} 
                                className={errorsForm.organization_name ? 'inputError' : ''}
                                placeholder='Полное наименование без сокращений' 
                                minLength='' 
                                maxLength='150' 
                                disabled={loading}
                                required />
                                {errorsForm.organization_name && <div className='errorUnderInput'>{errorsForm.organization_name}</div>}
                            </div>
                        </div>
                    </div>
                    <div className='labelInputWrapper'>
                        <a className='label'>Дата приема</a>
                        <div className='labelInputRight'>
                            <div className='inputWrapper'>
                                <input type='date' 
                                value={formInfo.admission_date?.split('T')[0]}
                                onChange={handleChange('admission_date')} 
                                className={errorsForm.admission_date ? 'inputError' : ''}
                                placeholder='' 
                                minLength='' 
                                maxLength='' 
                                disabled={loading}
                                required />
                                {errorsForm.admission_date && <div className='errorUnderInput'>{errorsForm.admission_date}</div>}
                            </div>
                        </div>
                    </div>
                    {formInfo.type==='Работа на руководящей должности' &&
                    <>
                        <div className='labelInputWrapper'>
                            <a className='label'>Должность</a>
                            <div className='labelInputRight'>
                                <div className='inputWrapper'>
                                    <input 
                                    type='text' 
                                    value={formInfo.job_title} 
                                    onChange={handleChange('job_title')} 
                                    className={errorsForm.job_title ? 'inputError' : ''}
                                    placeholder='' 
                                    minLength='' 
                                    maxLength='50' 
                                    disabled={loading}
                                    required />
                                    {errorsForm.job_title && <div className='errorUnderInput'>{errorsForm.job_title}</div>}
                                </div>
                            </div>
                        </div>
                        <div className='labelInputWrapper'>
                            <a className='label'>Дата ухода с должности (Не обязательно)</a>
                            <div className='labelInputRight'>
                                <div className='inputWrapper'>
                                    <input type='date' 
                                    value={formInfo.leaving_date?.split('T')[0]}
                                    onChange={handleChange('leaving_date')} 
                                    className={errorsForm.leaving_date ? 'inputError' : ''}
                                    placeholder='' 
                                    minLength='' 
                                    maxLength='' 
                                    disabled={loading}
                                    required />
                                    {errorsForm.leaving_date && <div className='errorUnderInput'>{errorsForm.leaving_date}</div>}
                                </div>
                            </div>
                        </div>
                    </>}
                    <div className='labelInputWrapper'>
                        <a className='label'>Скан {formInfo.type !== 'Работа на руководящей должности' ? 'свидетельства' : 'документа'}</a>
                        <div className='labelInputRight'>
                            {action=='add' ? 
                                <div className='inputWrapper'>
                                    <FileUploadField
                                        label='Прикрепить документ'
                                        file={files.certificate}
                                        buttonLabel='Прикрепить документ'
                                        onChange={handleFileChange('certificate')}
                                        onReset={handleFileReset('certificate')}
                                    />
                                    {errorsForm.certificate && <div className='errorUnderInput'>{errorsForm.certificate}</div>}
                                </div>
                            :
                                <div className='panel'>
                                    <p className='description'>Изменение файла у существующей записи невозможно</p>
                                </div>
                            }
                        </div>
                    </div>
                </div>
                <div className={styles.bottom}>
                    <div>{status}</div>
                    <button 
                    type='button' 
                    className='button' 
                    onClick={handleSave}
                    disabled={loading}
                    >
                        {action=='add' && 'Добавить'} 
                        {action=='change' && 'Изменить'} 
                    </button>
                </div>
            </div>
        </div>
    )
}

export default EditEmploymentHistory;